export default __webpack_public_path__ + "static/media/feature3.64887bc2.jpg";